export default {
  path: '',
  components: {
    default: () =>
      import(
        /* webpackChunkName: "catalog-layout" */ '@/modules/catalog/CatalogLayout.vue'
      ),
    overlay: () =>
      import(
        /* webpackChunkName: "overlay-tournament-catalog" */ '@/modules/tournament/views/OverlayTournamentCatalog'
      )
  },
  children: [
    {
      path: '/',
      name: 'Landing',
      meta: {
        defaultTab: 'featured'
      },
      component: () =>
        import(
          /* webpackChunkName: "landing" */ '@/modules/catalog/views/Landing'
        )
    },
    {
      path: 'active',
      name: 'ActiveTournamentCatalog',
      meta: {
        defaultTab: 'active'
      },
      component: () =>
        import(
          /* webpackChunkName: "active-tournament-catalog" */ '@/modules/catalog/views/ActiveTournamentCatalog'
        )
    },
    {
      path: 'past',
      name: 'PastTournamentCatalog',
      meta: {
        defaultTab: 'past'
      },
      component: () =>
        import(
          /* webpackChunkName: "recent-tournament-catalog" */ '@/modules/catalog/views/PastTournamentCatalog'
        )
    },
    {
      path: 'upcoming',
      name: 'UpcomingTournamentCatalog',
      meta: {
        defaultTab: 'upcoming'
      },
      component: () =>
        import(
          /* webpackChunkName: "upcoming-tournament-catalog" */ '@/modules/catalog/views/UpcomingTournamentCatalog'
        )
    },
    {
      path: 'top',
      name: 'TopTournamentCatalog',
      meta: {
        defaultTab: 'top'
      },
      component: () =>
        import(
          /* webpackChunkName: "top-tournament-catalog" */ '@/modules/catalog/views/TopTournamentCatalog'
        )
    }
  ]
}
